import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';

class ConfigMessage extends React.Component {
	renderLink() {
		const { linkText, linkURL } = this.props;
		if (!linkText || !linkURL) {
			return null;
		}
		return (
			<div>
				<br />
				<a
					href={linkURL}
					target="_blank"
					// Using target="_blank" without
					// rel="noopener" is a security risk:
					// https://html.spec.whatwg.org/multipage/links.html#link-type-noopener
					rel="noopener noreferrer"
				>
					{linkText}
				</a>
			</div>
		);
	}

	renderMessage() {
		const { message } = this.props;
		if (!message) {
			return null;
		}
		return (
			<div>
				<br />
				<span className="message">{message}</span>
			</div>
		);
	}

	render() {
		const { title, variant } = this.props;
		return (
			<div className={`empty ${variant}`}>
				<Glyphicon glyph={` gg icon-GG-${variant}`} />
				<div className="title">{title}</div>
				{this.renderMessage()}
				{this.renderLink()}
			</div>
		);
	}
}

ConfigMessage.propTypes = {
	title: PropTypes.string.isRequired,
	message: PropTypes.string,
	linkText: PropTypes.string,
	linkURL: PropTypes.string,
	variant: PropTypes.oneOf([
		'info',
		'warning'
	])
};

ConfigMessage.defaultProps = {
	variant: 'info'
};

export default ConfigMessage;
